import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './Table.module.scss'

export const TableSimple: FunctionComponent<Props> = ({
  className,
  children,
  alwaysStripy = false,
  ...rest
}) => {
  return (
    <table
      data-testid="table"
      className={classnames(
        styles.table,
        alwaysStripy && styles.alwaysStripy,
        className
      )}
      {...rest}
    >
      {children}
    </table>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Zebra striping is applied across all breakpoints
   */
  alwaysStripy?: boolean
  /**
   * Optional class name for augmenting the table class attribute.
   */
  className?: string
  children: ReactNode
} & HTMLProps<HTMLTableElement>
